<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule"  size="small" ref="dataForm"  label-width="120px"
     v-loading="dataLoading" style="width:65%;margin:auto;"  element-loading-text=""  element-loading-spinner="el-icon-loading"
    >
      <el-form-item label="固化条件编号" prop="no">
        <el-input v-model="dataForm.no" placeholder="固化条件编号"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="固化条件名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="固化条件名称"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="固化时间" prop="solTime">
        <el-input v-model="dataForm.solTime" placeholder="固化时间"  size="small" maxlength="5">
          <template slot="append">秒</template>
        </el-input>
      </el-form-item>
      <el-form-item label="固化温度" prop="temperature">
        <el-input v-model="dataForm.temperature" placeholder="固化温度"  size="small" maxlength="5">
          <template slot="append">℃</template>
        </el-input>
      </el-form-item>
      <el-form-item label="固化条件详情" prop="description">
        <el-input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 5}"
                v-model="dataForm.description"
                maxlength="150"
                placeholder="固化条件详情">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" size="small"  :disabled="dataLoading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {info,add,update} from '@/api/modules/solidifycondition'
  export default {
    data () {
      return {
        visible: false,
        dataLoading: false,
        dataForm: {
          id: 0,
          no: '',
          name: '',
          solTime: '',
          temperature: '',
          description: ''
        },
        dataRule: {
          no: [
            { required: true, message: '固化条件编号不能为空', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '固化条件名称不能为空', trigger: 'blur' }
          ],
          solTime: [
            { required: true, message: '固化时间不能为空', trigger: 'blur' }
          ],
          temperature: [
            { required: true, message: '固化温度不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            info({id:this.dataForm.id}).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.no = data.solidifyCondition.no
                this.dataForm.name = data.solidifyCondition.name
                this.dataForm.solTime = data.solidifyCondition.solTime
                this.dataForm.temperature = data.solidifyCondition.temperature
                this.dataForm.description = data.solidifyCondition.description
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
          	this.dataLoading = true;
            var params = {
              'id': this.dataForm.id || undefined,
              'no': this.dataForm.no,
              'name': this.dataForm.name,
              'solTime': this.dataForm.solTime,
              'temperature': this.dataForm.temperature,
              'description': this.dataForm.description
            }
            var tick = !this.dataForm.id ? add(params) : update(params)
            tick.then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
	              	this.dataLoading = false;
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
                this.dataLoading = false;
              }
            })
          }
        })
      }
    }
  }
</script>
